/**
 * dataService.js
 *
 * Desktop (Electron): LOCAL-FIRST
 *   All reads and writes go to local SQLite immediately.
 *   syncService.js keeps SQLite in sync with Supabase in the background.
 *   This means the UI is always responsive and works fully offline.
 *
 * Browser: always Supabase.
 */

const isDesktop = !!window.menuronDesktop?.isDesktop

let restaurantService, billingService, posService, crmService, analyticsService, menuService, staffService

if (isDesktop) {
  // Local-first: always read/write SQLite. Background sync handles Supabase.
  const local = require('./localService')
  restaurantService = local.restaurantService
  billingService    = local.billingService
  posService        = local.posService
  crmService        = local.crmService
  analyticsService  = local.analyticsService
  menuService       = local.menuService
  staffService      = local.staffService
} else {
  // Browser: always Supabase
  const remote = require('./supabase')
  restaurantService = remote.restaurantService
  billingService    = remote.billingService
  posService        = remote.posService
  crmService        = remote.crmService
  analyticsService  = remote.analyticsService
  menuService       = remote.menuService
  staffService      = remote.authService  // authService has getRestaurantManagers/Waiters/addWaiter etc.
}

// Always export supabase client directly (used for auth + realtime channels)
export { supabase } from './supabase'
export { orderService } from './supabase'

export { restaurantService, billingService, posService, crmService, analyticsService, menuService, staffService }
